import {EventBase} from "shared/utilities/Events/EventManager";
import {FieldItemBase} from "InternalShared/PageBuilder/Fields/FieldItemBase";

export class GetAdvancedField extends EventBase {
    ReturnType: FieldItemBase<any,any>[];

    constructor() {
        super();
    }

    public static GetName() {
        return 'GetAdvancedField';
    }


}